import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

interface MenuProps {
  open: boolean;
}

export const Menu = styled.div<MenuProps>`
  position: absolute;
  right: 30px;

  background: ${ColorPalette.HEX.White};
  box-shadow: 0 2px 8px 0 rgba(${ColorPalette.RGB.Black}, 0.2);
  min-width: 250px;
  opacity: ${({ open }) => (open ? 100 : 0)}%;
  transform: ${({ open }) => `translateY(calc(100% + ${open ? 20 : 0}px))`};
  transition: transform ease-in-out 0.5s, opacity ease-in-out 0.5s;

  pointer-events: ${({ open }) => (open ? 'inherit' : 'none')};
  border-radius: 12px;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 16px;
  font-size: 16px;
  text-align: right;
  color: ${ColorPalette.HEX.DimGray};
  cursor: pointer;
  user-select: none;

  &:hover {
    background: ${ColorPalette.HEX.FloralWhite};
  }
`;

export const MenuItemIcon = styled.img`
  margin-right: 16px;
  width: 24px;
`;

export const User: any = styled.div`
  color: ${ColorPalette.HEX.DimGray};
  padding: 15px;
  user-select: none;
`;
User.Title = styled.div`
  font-size: 10px;
  text-transform: uppercase;
  line-height: 1.4em;
`;
User.Name = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4em;
`;
User.Email = styled.div`
  font-size: 12px;
  line-height: 1.4em;
`;

export const Company: any = styled.div`
  color: ${ColorPalette.HEX.DimGray};
  padding: 0 15px 15px 15px;
  user-select: none;
`;
Company.Title = styled.div`
  font-size: 10px;
  text-transform: uppercase;
  line-height: 1.4em;
`;
Company.Name = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4em;
`;
Company.Country = styled.div`
  font-size: 12px;
  line-height: 1.4em;
`;

export const ChangeCompany = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  margin: 10px 0px 0px 0px;
  font-size: 11px;
  text-align: right;
  color: ${ColorPalette.HEX.DimGray};
  cursor: pointer;
  user-select: none;

  &:hover {
    color: ${ColorPalette.HEX.OriolesOrange};
  }
`;

export const ChangeCompanyIcon = styled.img`
  margin-right: 16px;
  width: 24px;
`;
